import { ActionReducer, combineReducers } from "@ngrx/store";
// import { User } from "../model/user.model";
import { AuthData } from "../model/auth-data.model";
import { userReducer, AuthUserState } from "./reducers/auth-user.reducer";
import { DialogModel } from "../components/dialog/dialogModel";
import { SharedCommonReducer, SharedCommonState } from "./reducers/‏‏shared-common.reducer";


const reducers = {
    authUserState: userReducer,
    commonState: SharedCommonReducer,
};

interface CommonState {
    authUserState: AuthUserState;
    commonState: SharedCommonState;
}

const reducer: ActionReducer<CommonState> = combineReducers(reducers);

function commonReducer(state: any, action: any) {
    return reducer(state, action);
}

export { commonReducer, CommonState };

// export selectors
export const selectAuthData = (state: CommonState) => state.authUserState.authData as AuthData;
export const selectRole = (state: CommonState) => state.authUserState.authData?.role;

export const selectLanguage = (state: CommonState) => state.commonState.language;
export const selectCurrency = (state: CommonState) => state.commonState.currency;
export const selectIsLoading = (state: CommonState) => state.commonState.isLoading;
export const selectDialog = (state: CommonState) => state.commonState.dialog as DialogModel;
export const selectDisplayLoginDialog = (state: CommonState) => state.commonState.displayLoginDialog;
export const selectBlockDocument = (state: CommonState) => state.commonState.blockDocument;
export const selectCurrentPageTitle = (state: CommonState) => state.commonState.currentPageTitle;

